var React = require('react');

function IcMailComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.34729","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M4.5 4.5H13.5C13.7761 4.5 14 4.72386 14 5V13C14 13.2761 13.7761 13.5 13.5 13.5H4.5C4.22386 13.5 4 13.2761 4 13V5C4 4.72386 4.22386 4.5 4.5 4.5ZM13 6.61896L9.0359 10.169L5 6.60797V12.5H13V6.61896ZM5.25573 5.5L9.03095 8.831L12.7505 5.5H5.25573Z","fill":"#3E3E3E","key":1})]));
}

IcMailComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcMailComponent;

IcMailComponent.default = IcMailComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifSectionV2/images/ic-mail.component.svg
// module id = 415
// module chunks = 0